import React from 'react';

import { Box, Collapse, Group, Stack, Text, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronRight } from '@tabler/icons-react';
import ReadonlyWorkoutNotesRTE from 'components/workout-program/ReadonlyWorkoutNotesRTE';

interface AthleteLegacyClassNotesProps {
  notes?: string | null;
}

const AthleteLegacyClassNotes = ({ notes }: AthleteLegacyClassNotesProps): JSX.Element | null => {
  const theme = useMantineTheme();
  const [isOpened, { toggle }] = useDisclosure();

  if (!notes?.trim()) return null;

  return (
    <Box>
      <Group noWrap onClick={toggle} spacing='xs' sx={{ cursor: 'pointer' }}>
        <Text color='dimmed' fs='italic'>
          Legacy Programming
        </Text>
        <IconChevronRight
          color={theme.colors.dark[3]}
          size={theme.fontSizes.lg}
          style={{
            transform: isOpened ? 'rotate(90deg)' : 'unset',
            transition: 'ease-in 100ms',
          }}
        />
      </Group>
      <Collapse in={isOpened} transitionTimingFunction='linear'>
        <Stack spacing='xs' pt='lg'>
          <ReadonlyWorkoutNotesRTE workoutNotes={notes} />
        </Stack>
      </Collapse>
    </Box>
  );
};

export default AthleteLegacyClassNotes;
